export default __webpack_public_path__ + "static/media/social.b158aa0f.png";